import React, { FunctionComponent, useCallback, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { ModalConfirm } from '../../../../../../shared/components';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { useActions } from '../../../../../../shared/hooks';
import { selectIsCloudRecordingStopModalOpened } from '../../selectors';
import { closeCloudRecordingStopModalAction } from '../../slice';

export const CloudRecordingStopModal: FunctionComponent = () => {
    const { closeCloudRecordingStopModal } = useActions({
        closeCloudRecordingStopModal: closeCloudRecordingStopModalAction,
    });

    const isCloudRecordingStopModalOpened = useSelector(selectIsCloudRecordingStopModalOpened);

    const closeModal = useCallback(
        (isConfirmed: boolean) => {
            closeCloudRecordingStopModal(isConfirmed);
            countMetrika('meeting_screen', 'cloud-recording', 'stop_recording', isConfirmed ? 'allow' : 'deny');
        },
        [closeCloudRecordingStopModal]
    );

    const onClose = useCallback(() => closeModal(false), [closeModal]);
    const onConfirm = useCallback(() => closeModal(true), [closeModal]);

    useEffect(() => countMetrika('meeting_screen', 'cloud-recording', 'stop_popup_was_shown'), []);

    if (!isCloudRecordingStopModalOpened) {
        return null;
    }

    return (
        <ModalConfirm
            headerText={i18n('cloud-recording', 'stop-modal-header')}
            cancelButtonText={i18n('cloud-recording', 'stop-modal-cancel')}
            confirmButtonText={i18n('cloud-recording', 'stop-modal-confirm')}
            onConfirm={onConfirm}
            onClose={onClose}
        >
            {i18n('cloud-recording', 'stop-modal-description')}
        </ModalConfirm>
    );
};
